import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as reportApi from '../api/PomReport';
import { IPomReportDataInfo, IUserCompanies } from '../util/DataModelInterface'
import * as storage from '../util/StorageUtil';
import { reportListView } from '../components/CommonControls';
import { ReportStatus } from '../components/ReportStatus';
import { Spinner } from '../components/Spinner';
import useToastHandler from '../hooks/useToastHandler';

export const Reports = () => {
    const { instance } = useMsal();
    const { addToast } = useToastHandler();

    const [selectedCompany, setSelectedCompany] = useState({} as IUserCompanies);
    const [reports, setReports] = useState([] as IPomReportDataInfo[]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      let activeAccount = instance.getActiveAccount();
      if(activeAccount) {
        const userData = storage.getUser();
        console.log("Reports - user: ", userData);
        let companies = userData?.companies ? userData?.companies : [];
        let firstCompany = companies.length > 0 ? companies[0] : {} as IUserCompanies;
        let selectedComp = userData?.selected_comp ? userData?.selected_comp : firstCompany;
        setSelectedCompany(selectedComp);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      if (selectedCompany.id) {
        setLoading(true);
        let id = parseInt(selectedCompany.id);
        reportApi.getReportStatus([id]).then((data: any) => {
            if (data?.error) {
              addToast(data.error, 'reports', 'fetch');
            } else if (data) {
              setReports(data);
            }
        }).finally(() => {
          setLoading(false);
        });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany]);

    return (
      <>
        <Spinner active={loading} />
        <div>
          <h1><FormattedMessage id="reports.reports"/> {selectedCompany.name ? " - " + selectedCompany.name : ""}</h1>
          <p className="info"><i className="fa fa-info-circle me-2"></i><FormattedMessage id="reports.statusinfo"/></p>
          <ReportStatus selectedCompany={selectedCompany}/>
          {reportListView(selectedCompany.name, reports)}
        </div>
      </>
    );
};